export const FETCH_PLAN = "FETCH_PLAN";
export const FETCH_PLAN_SUCCESS = "FETCH_PLAN_SUCCESS";
export const FETCH_PLAN_FAIL = "FETCH_PLAN_FAIL";